import { DefaultError, useMutation } from "@tanstack/react-query";
import {
  MODULE_THREE_CARDS_BLOCKS,
  MODULE_TOP_PRIVACY_TIPS_BLOCK,
} from "modules/moduleTemplates/components/ModuleDetailsDrawer/context/constants";
import { invalidateImageFilesQueries } from "shared/queries/useImageFileQueries";
import { updateModuleTemplate } from "../api/updateModuleTemplate";
import { invalidateActiveModuleTemplateListQuery } from "../queries/useActiveModuleTemplateList";
import { invalidateModuleTemplatePagedListQuery } from "../queries/useModuleTemplatePagedListQuery";
import { invalidateModuleTemplate } from "../queries/useModuleTemplateQuery";
import { CardBlockImage, ModuleDataToUpdate } from "../types";
import { getImageKey } from "../utils";

type Params = {
  moduleId: string;
  data: ModuleDataToUpdate;
  cardBlockImages: CardBlockImage[];
  topPrivacyTipsBlockImage: CardBlockImage;
};

export const useUpdateModuleMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await updateModuleTemplate(
        params.moduleId,
        params.data,
        params.cardBlockImages,
        params.topPrivacyTipsBlockImage,
      );
    },
    onSuccess: (_, { cardBlockImages, moduleId, topPrivacyTipsBlockImage }) => {
      invalidateModuleTemplatePagedListQuery();
      invalidateActiveModuleTemplateListQuery();
      invalidateModuleTemplate(moduleId);

      if (cardBlockImages.some((item) => item instanceof File)) {
        cardBlockImages.forEach((image, index) => {
          if (image) {
            const imageQueryKey = getImageKey(MODULE_THREE_CARDS_BLOCKS, index);
            invalidateImageFilesQueries([[imageQueryKey, moduleId]]);
          }
        });
      }

      if (topPrivacyTipsBlockImage) {
        const imageQueryKey = `${MODULE_TOP_PRIVACY_TIPS_BLOCK}-image`;
        invalidateImageFilesQueries([[imageQueryKey, moduleId]]);
      }
    },
    onError: (e) => {
      console.error("Error occurred when creating module", e);
    },
  });
};
